export default {
  name: 'LinksFooter',
  props: {
    hideEmail: String,
    overrideEmail: String,
    hidePolicies: String
  }
};